import {
	Inject,
	Injectable,
	Directive,
	HostListener,
	Input,
	Optional,
} from "@angular/core";
import { TealiumService } from "../services/tealium.service";

@Injectable()
@Directive({
    // tslint:disable-next-line:directive-selector
    selector: "[TealiumContext]",
    providers: [TealiumContextDirective],
    standalone: false
})
export class TealiumContextDirective {
	// tslint:disable-next-line:no-input-rename
	@Input("TealiumContext")
	tealiumData: object;
}

// tslint:disable-next-line:directive-selector
@Directive({
    selector: "[TealiumLink]",
    standalone: false
})
export class TealiumLinkDirective {
	// tslint:disable-next-line:no-input-rename
	@Input("TealiumLink")
	tealiumData: object;
	constructor(
		@Optional()
		@Inject(TealiumContextDirective)
		private context: TealiumContextDirective,
		private service: TealiumService
	) {}

	// Clicks are sometimes obscured by existing event listeners, so use mouse down
	@HostListener("click", ["$event"])
	onClick(event: MouseEvent) {
		const data = Object.assign({}, this.contextData(), this.tealiumData);

		let parentElement: Element | any = event["toElement"]
			? event["toElement"]
			: event["target"] || event["relatedTarget"];

		switch (data["interaction_type"]) {
			case "yes-no-buttons":
				while (
					parentElement.nodeName.toLowerCase() !== "body" &&
					parentElement.nodeName.toLowerCase() !== "yes-no-buttons"
				) {
					parentElement = parentElement.parentElement;
				}
				const question =
					parentElement.getElementsByClassName("content")[0]
						.textContent;
				data["interaction_value"] = question;
				break;
			case "button":
				data["link_label"] = parentElement.textContent;
		}

		this.service.trackPageEvent(data);
	}

	contextData() {
		return this.context ? this.context.tealiumData : {};
	}
}
